export const INTERIOR_VIEW_CROSS_SECTION_COLOR = 0x737373;
export const CROSS_SECTION_Z_FIGHTING_OFFSET = 0.3;
